'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var date = require('@internationalized/date');

/**
 * `createCalendar`
 *
 * Only supports gregorian calendars. For more information, check out `react-aria`s documentation.
 *
 * @see https://react-spectrum.adobe.com/react-aria/useDateField.html#reducing-bundle-size.
 */
function createCalendar() {
  var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'gregory';
  switch (identifier) {
    case 'gregory':
      return new date.GregorianCalendar();
    default:
      throw new Error("Calendar ".concat(identifier, " is not supported."));
  }
}
exports.createCalendar = createCalendar;